import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { navigationLinks } from '@/mocks/navigationLinks';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            按需选择分类，快速找到您需要的入口链接
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => {
            const links = navigationLinks[cat.slug] || [];
            const onlineCount = links.filter((l) => l.status === 'online').length;

            const colorMap: Record<string, { iconBg: string; iconText: string }> = {
              primary: { iconBg: 'bg-primary-100', iconText: 'text-primary-600' },
              accent: { iconBg: 'bg-accent-100', iconText: 'text-accent-600' },
              secondary: { iconBg: 'bg-secondary-100', iconText: 'text-secondary-600' },
            };
            const c = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block no-underline bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300 group"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${c.iconBg} mb-4`}>
                  <i className={`${cat.icon} text-xl ${c.iconText}`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    {onlineCount}/{links.length} 个可用入口
                  </span>
                  <span className="flex items-center gap-1 text-xs text-primary-600 font-medium whitespace-nowrap">
                    查看详情
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}